var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBusiness(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4279_39394)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.1667 4.66667H20.8833C20.6126 3.34998 19.8961 2.1669 18.8548 1.31684C17.8135 0.466772 16.5109 0.00169695 15.1667 0L12.8333 0C11.4891 0.00169695 10.1865 0.466772 9.14521 1.31684C8.10388 2.1669 7.38745 3.34998 7.11667 4.66667H5.83333C4.28681 4.66852 2.80415 5.2837 1.71059 6.37726C0.617029 7.47082 0.0018525 8.95347 0 10.5L0 14H28V10.5C27.9981 8.95347 27.383 7.47082 26.2894 6.37726C25.1959 5.2837 23.7132 4.66852 22.1667 4.66667ZM9.548 4.66667C9.78843 3.98661 10.2331 3.39744 10.8212 2.97977C11.4093 2.5621 12.112 2.33632 12.8333 2.33333H15.1667C15.888 2.33632 16.5907 2.5621 17.1788 2.97977C17.7669 3.39744 18.2116 3.98661 18.452 4.66667H9.548Z",
    fill: "#65707B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1667 17.5006C15.1667 17.8101 15.0437 18.1068 14.825 18.3256C14.6062 18.5444 14.3094 18.6673 14 18.6673C13.6906 18.6673 13.3938 18.5444 13.175 18.3256C12.9562 18.1068 12.8333 17.8101 12.8333 17.5006V16.334H0V22.1673C0.0018525 23.7138 0.617029 25.1965 1.71059 26.29C2.80415 27.3836 4.28681 27.9988 5.83333 28.0006H22.1667C23.7132 27.9988 25.1959 27.3836 26.2894 26.29C27.383 25.1965 27.9981 23.7138 28 22.1673V16.334H15.1667V17.5006Z",
    fill: "#65707B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4279_39394"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusiness);
export default ForwardRef;